import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {WelfareResultService} from '@core/service/welfare-result.service';
import {ApiService} from '@core/service/api.service';
import {ResultComponent} from './result/result.component';
import {ActivatedRoute, Router} from '@angular/router';
import {WelfareProject} from 'src/app/core/class/welfare-project';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {PersonKind} from '@core/class/person-kind.enum';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AppState} from '@app/redux';
import {loadProject, saveProject} from '@app/welfy-plugin/welfy/calculator/redux/simulation.actions';
import {Observable} from 'rxjs';
import {selectCurrentProject} from '@app/welfy-plugin/welfy/calculator/redux';
import {navigateTo} from '@app/redux/app.actions';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.css'],
})
export class CalculatorComponent implements OnInit {
  showResult = false;
  isSaving = false;

  savingForm: FormGroup;

  // TODO: Move saving dialog in a single component and show input name only if the saving project not has name
  savingDialog;

  warningDialog;

  @ViewChild('invalidProjectDialog')
  invalidProjectDialog;

  @ViewChild('resultComponent')
  resultComponent: ResultComponent;

  project$: Observable<WelfareProject> = this.state.select(selectCurrentProject);

  constructor(
    public welfareService: WelfareResultService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private dialogService: NbDialogService,
    private state: Store<AppState>
  ) {
  }

  get projectName() {
    return this.savingForm.get('projectName');
  }

  ngOnInit() {
    this.savingForm = new FormGroup({
      projectName: new FormControl([Validators.required]),
    });

    const projectID = this.activatedRoute.snapshot.queryParams.id;

    if (projectID) {
      this.state.dispatch(loadProject({id: projectID}));
    }

    this.project$.subscribe(value => {
      if (value) {
        this.welfareService.welfareProject = JSON.parse(JSON.stringify(value));
        if (this.welfareService.projectResult) {
          this.showResult = true;
          this.resultComponent.computeResult();
        }
      } else {
        this.state.dispatch(navigateTo({path: '/'}));
      }
    })
    // get configuration from server
    /*this.apiService.getFrontedConfiguration().subscribe((configuration) => {
      this.welfareService.config = configuration;

      this.activatedRoute.queryParams.subscribe((value) => {
        const projectID = value.project;
        const customerID = value.c;

        if (projectID) {
          // load project from id
          this.apiService
            .loadProjectByID(projectID, "welfy")
            .subscribe((project) => {
              if (project) {
                this.welfareService.welfareProject = project;
                if (this.welfareService.projectResult) {
                  this.showResult = true;
                  this.resultComponent.computeResult();
                }
              } else {
                // show error dialog
                this.openInvalidProjecDialog(this.invalidProjectDialog);
              }
            });
        } else {
          // create new project
          this.welfareService.welfare = new WelfareProject();

          // show simulation type choose dialog
          this.openTypeSimulationDialog(customerID);
        }
      });
    });*/
  }

  showResults(dialog) {
    if (this.isValid()) {
      this.showResult = true;
      this.resultComponent.computeOnlineResult();
    } else {
      this.warningDialog = this.dialogService.open(dialog, {context: ''});
    }
  }

  openSavingDialog(dialog: TemplateRef<any>) {
    this.savingDialog = this.dialogService.open(dialog, {context: ''});
  }

  openInvalidProjecDialog(dialog: TemplateRef<any>) {
    this.invalidProjectDialog = this.dialogService.open(dialog, {
      context: '',
    });
  }

  closeAndRedirect(dialog: NbDialogRef<any>) {
    dialog.close();

    // redirect to project load page
    this.route.navigate(['simulations/load']);
  }

  countFamilyHead() {
    let ret = 0;

    this.welfareService.persons.forEach((value) => {
      if (value.kind === PersonKind.SINGLE) {
        ret++;
      }
    });

    return ret;
  }

  saveProject(showResult?: boolean) {
    if (this.savingForm.valid) {
      if (this.welfareService.welfare.creationTime == null) {
        // set creation date
        this.welfareService.welfare.creationTime = new Date();
      } else {
        this.welfareService.welfare.lastMod = new Date();
      }
      this.state.dispatch(saveProject({project: this.welfareService.welfare}));
    }
  }

  private isValid() {
    let ret = false;

    if (this.welfareService.persons) {
      if (this.welfareService.isSingle()) {
        this.welfareService.persons.forEach((value) => {
          if (
            value.kind === PersonKind.SINGLE &&
            this.countFamilyHead() === 1
          ) {
            ret = true;
          }
        });
      } else {
        let husband = null;
        let wife = null;

        this.welfareService.persons.forEach((value) => {
          if (value.kind === PersonKind.HUSBAND) {
            husband = value;
          } else if (value.kind === PersonKind.WIFE) {
            wife = value;
          }
        });
        ret = husband !== null && wife !== null;
      }
    }
    return ret;
  }
}
